const r = "transparent", t = [
  "#3366FF",
  "#16B6D1",
  "#32BEA5",
  "#35B254",
  "#FFBF00",
  "#F67B16",
  "#E86363",
  "#E373BD",
  "#846BF5",
  "#FFFFFF",
  "#C5C7CF",
  "#8D919E",
  "#222222"
], e = {
  "#3366FF": "bold cobalt blue",
  "#16B6D1": "bright aqua blue",
  "#32BEA5": "turquoise",
  "#35B254": "true green",
  "#FFBF00": "golden yellow",
  "#F67B16": "pumpkin orange",
  "#E86363": "coral red",
  "#E373BD": "taffy pink",
  "#846BF5": "vivid purple",
  "#FFFFFF": "white",
  "#C5C7CF": "light gray",
  "#8D919E": "dark gray",
  "#222222": "black"
}, F = "rgba(0, 0, 0, 0) url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAARElEQVQ4T2NkYGAQAWLsgBco/JnhDU55oAQjXgMYwCaQbwDEARS5AOx48l0A9ftIMABfNIPkcKcTaDoYNYBQCAz6QAQAKKALsSlrCy0AAAAASUVORK5CYII=') repeat scroll left center", a = (A) => {
  if (A.toLowerCase() === "transparent")
    return "transparent";
  if (A in e)
    return e[A];
};
export {
  t as DEFAULT_COLORS,
  e as DEFAULT_COLOR_LABELS,
  r as NO_COLOR,
  a as getColorName,
  F as transparentChecker
};
